export interface PlatformTheme {
  id: string;
  name: string;
  description: string;
  light: ThemeColors;
  dark: ThemeColors;
}

export interface ThemeColors {
  background: string;
  foreground: string;
  card: string;
  cardForeground: string;
  primary: string;
  primaryForeground: string;
  secondary: string;
  secondaryForeground: string;
  muted: string;
  mutedForeground: string;
  accent: string;
  accentForeground: string;
  border: string;
  sidebar: string;
  sidebarForeground: string;
  sidebarPrimary: string;
  sidebarAccent: string;
}

export const PLATFORM_THEMES: PlatformTheme[] = [
  {
    id: "app-maisters",
    name: "App Maisters",
    description: "Default navy & sky-blue brand theme",
    light: {
      background: "230 30% 98%",
      foreground: "230 35% 12%",
      card: "0 0% 100%",
      cardForeground: "230 35% 12%",
      primary: "262 65% 58%",
      primaryForeground: "0 0% 100%",
      secondary: "230 25% 95%",
      secondaryForeground: "230 35% 18%",
      muted: "230 25% 95%",
      mutedForeground: "230 12% 42%",
      accent: "262 65% 58%",
      accentForeground: "0 0% 100%",
      border: "230 20% 90%",
      sidebar: "232 35% 12%",
      sidebarForeground: "230 18% 88%",
      sidebarPrimary: "262 70% 65%",
      sidebarAccent: "232 30% 18%",
    },
    dark: {
      background: "220 30% 6%",
      foreground: "220 15% 92%",
      card: "220 30% 8%",
      cardForeground: "220 15% 92%",
      primary: "220 55% 22%",
      primaryForeground: "0 0% 100%",
      secondary: "220 20% 16%",
      secondaryForeground: "220 15% 92%",
      muted: "220 20% 14%",
      mutedForeground: "220 10% 65%",
      accent: "199 89% 50%",
      accentForeground: "0 0% 100%",
      border: "220 20% 14%",
      sidebar: "220 55% 8%",
      sidebarForeground: "220 15% 90%",
      sidebarPrimary: "199 89% 50%",
      sidebarAccent: "220 50% 14%",
    },
  },
  {
    id: "ocean-blue",
    name: "Ocean Blue",
    description: "Clean blue tones with a calming feel",
    light: {
      background: "210 40% 98%",
      foreground: "210 40% 10%",
      card: "210 40% 100%",
      cardForeground: "210 40% 10%",
      primary: "210 100% 40%",
      primaryForeground: "0 0% 100%",
      secondary: "210 30% 90%",
      secondaryForeground: "210 40% 12%",
      muted: "210 25% 93%",
      mutedForeground: "210 15% 40%",
      accent: "190 90% 45%",
      accentForeground: "0 0% 100%",
      border: "210 25% 88%",
      sidebar: "210 80% 18%",
      sidebarForeground: "210 20% 93%",
      sidebarPrimary: "190 90% 50%",
      sidebarAccent: "210 70% 24%",
    },
    dark: {
      background: "210 40% 5%",
      foreground: "210 20% 92%",
      card: "210 40% 7%",
      cardForeground: "210 20% 92%",
      primary: "210 100% 45%",
      primaryForeground: "0 0% 100%",
      secondary: "210 25% 16%",
      secondaryForeground: "210 20% 92%",
      muted: "210 25% 13%",
      mutedForeground: "210 15% 60%",
      accent: "190 90% 50%",
      accentForeground: "0 0% 100%",
      border: "210 25% 14%",
      sidebar: "210 80% 8%",
      sidebarForeground: "210 20% 90%",
      sidebarPrimary: "190 90% 50%",
      sidebarAccent: "210 70% 14%",
    },
  },
  {
    id: "emerald",
    name: "Emerald",
    description: "Fresh green palette for eco-friendly brands",
    light: {
      background: "150 20% 97%",
      foreground: "150 40% 8%",
      card: "150 20% 99%",
      cardForeground: "150 40% 8%",
      primary: "152 70% 28%",
      primaryForeground: "0 0% 100%",
      secondary: "150 15% 90%",
      secondaryForeground: "150 40% 10%",
      muted: "150 15% 92%",
      mutedForeground: "150 10% 40%",
      accent: "160 80% 42%",
      accentForeground: "0 0% 100%",
      border: "150 15% 88%",
      sidebar: "152 60% 14%",
      sidebarForeground: "150 20% 92%",
      sidebarPrimary: "160 80% 45%",
      sidebarAccent: "152 55% 20%",
    },
    dark: {
      background: "150 30% 5%",
      foreground: "150 15% 92%",
      card: "150 30% 7%",
      cardForeground: "150 15% 92%",
      primary: "152 70% 32%",
      primaryForeground: "0 0% 100%",
      secondary: "150 20% 14%",
      secondaryForeground: "150 15% 92%",
      muted: "150 20% 12%",
      mutedForeground: "150 10% 60%",
      accent: "160 80% 45%",
      accentForeground: "0 0% 100%",
      border: "150 20% 14%",
      sidebar: "152 60% 7%",
      sidebarForeground: "150 15% 90%",
      sidebarPrimary: "160 80% 45%",
      sidebarAccent: "152 55% 12%",
    },
  },
  {
    id: "royal-purple",
    name: "Royal Purple",
    description: "Elegant purple with violet accents",
    light: {
      background: "270 20% 97%",
      foreground: "270 40% 10%",
      card: "270 20% 99%",
      cardForeground: "270 40% 10%",
      primary: "270 60% 35%",
      primaryForeground: "0 0% 100%",
      secondary: "270 15% 90%",
      secondaryForeground: "270 40% 12%",
      muted: "270 15% 92%",
      mutedForeground: "270 10% 40%",
      accent: "280 80% 55%",
      accentForeground: "0 0% 100%",
      border: "270 15% 88%",
      sidebar: "270 55% 14%",
      sidebarForeground: "270 20% 92%",
      sidebarPrimary: "280 80% 58%",
      sidebarAccent: "270 50% 20%",
    },
    dark: {
      background: "270 30% 5%",
      foreground: "270 15% 92%",
      card: "270 30% 7%",
      cardForeground: "270 15% 92%",
      primary: "270 60% 40%",
      primaryForeground: "0 0% 100%",
      secondary: "270 20% 16%",
      secondaryForeground: "270 15% 92%",
      muted: "270 20% 13%",
      mutedForeground: "270 10% 60%",
      accent: "280 80% 58%",
      accentForeground: "0 0% 100%",
      border: "270 20% 14%",
      sidebar: "270 55% 7%",
      sidebarForeground: "270 15% 90%",
      sidebarPrimary: "280 80% 58%",
      sidebarAccent: "270 50% 12%",
    },
  },
  {
    id: "sunset-rose",
    name: "Sunset Rose",
    description: "Warm rose and coral tones",
    light: {
      background: "350 30% 97%",
      foreground: "350 40% 10%",
      card: "350 30% 99%",
      cardForeground: "350 40% 10%",
      primary: "350 70% 40%",
      primaryForeground: "0 0% 100%",
      secondary: "350 15% 90%",
      secondaryForeground: "350 40% 12%",
      muted: "350 15% 92%",
      mutedForeground: "350 10% 42%",
      accent: "15 90% 55%",
      accentForeground: "0 0% 100%",
      border: "350 15% 88%",
      sidebar: "350 55% 15%",
      sidebarForeground: "350 20% 92%",
      sidebarPrimary: "15 90% 55%",
      sidebarAccent: "350 50% 22%",
    },
    dark: {
      background: "350 30% 5%",
      foreground: "350 15% 92%",
      card: "350 30% 7%",
      cardForeground: "350 15% 92%",
      primary: "350 70% 42%",
      primaryForeground: "0 0% 100%",
      secondary: "350 20% 14%",
      secondaryForeground: "350 15% 92%",
      muted: "350 20% 12%",
      mutedForeground: "350 10% 60%",
      accent: "15 90% 55%",
      accentForeground: "0 0% 100%",
      border: "350 20% 14%",
      sidebar: "350 55% 7%",
      sidebarForeground: "350 15% 90%",
      sidebarPrimary: "15 90% 55%",
      sidebarAccent: "350 50% 12%",
    },
  },
  {
    id: "charcoal",
    name: "Charcoal",
    description: "Sleek neutral grays with teal accents",
    light: {
      background: "0 0% 97%",
      foreground: "0 0% 10%",
      card: "0 0% 100%",
      cardForeground: "0 0% 10%",
      primary: "0 0% 18%",
      primaryForeground: "0 0% 100%",
      secondary: "0 0% 90%",
      secondaryForeground: "0 0% 12%",
      muted: "0 0% 93%",
      mutedForeground: "0 0% 42%",
      accent: "175 75% 40%",
      accentForeground: "0 0% 100%",
      border: "0 0% 88%",
      sidebar: "0 0% 10%",
      sidebarForeground: "0 0% 92%",
      sidebarPrimary: "175 75% 45%",
      sidebarAccent: "0 0% 16%",
    },
    dark: {
      background: "0 0% 5%",
      foreground: "0 0% 92%",
      card: "0 0% 7%",
      cardForeground: "0 0% 92%",
      primary: "0 0% 25%",
      primaryForeground: "0 0% 100%",
      secondary: "0 0% 14%",
      secondaryForeground: "0 0% 92%",
      muted: "0 0% 12%",
      mutedForeground: "0 0% 60%",
      accent: "175 75% 45%",
      accentForeground: "0 0% 100%",
      border: "0 0% 14%",
      sidebar: "0 0% 5%",
      sidebarForeground: "0 0% 90%",
      sidebarPrimary: "175 75% 45%",
      sidebarAccent: "0 0% 10%",
    },
  },
  {
    id: "amber-gold",
    name: "Amber Gold",
    description: "Warm amber and gold for premium feel",
    light: {
      background: "40 30% 97%",
      foreground: "30 40% 10%",
      card: "40 30% 99%",
      cardForeground: "30 40% 10%",
      primary: "30 80% 35%",
      primaryForeground: "0 0% 100%",
      secondary: "40 15% 90%",
      secondaryForeground: "30 40% 12%",
      muted: "40 15% 92%",
      mutedForeground: "30 10% 40%",
      accent: "38 95% 50%",
      accentForeground: "30 80% 10%",
      border: "40 15% 88%",
      sidebar: "30 55% 14%",
      sidebarForeground: "40 20% 92%",
      sidebarPrimary: "38 95% 52%",
      sidebarAccent: "30 50% 20%",
    },
    dark: {
      background: "30 30% 5%",
      foreground: "40 15% 92%",
      card: "30 30% 7%",
      cardForeground: "40 15% 92%",
      primary: "30 80% 38%",
      primaryForeground: "0 0% 100%",
      secondary: "30 20% 14%",
      secondaryForeground: "40 15% 92%",
      muted: "30 20% 12%",
      mutedForeground: "30 10% 60%",
      accent: "38 95% 52%",
      accentForeground: "30 80% 10%",
      border: "30 20% 14%",
      sidebar: "30 55% 7%",
      sidebarForeground: "40 15% 90%",
      sidebarPrimary: "38 95% 52%",
      sidebarAccent: "30 50% 12%",
    },
  },
  {
    id: "slate-indigo",
    name: "Slate Indigo",
    description: "Modern slate with indigo highlights",
    light: {
      background: "225 20% 97%",
      foreground: "225 40% 10%",
      card: "225 20% 99%",
      cardForeground: "225 40% 10%",
      primary: "235 55% 45%",
      primaryForeground: "0 0% 100%",
      secondary: "225 15% 90%",
      secondaryForeground: "225 40% 12%",
      muted: "225 15% 92%",
      mutedForeground: "225 10% 40%",
      accent: "240 80% 60%",
      accentForeground: "0 0% 100%",
      border: "225 15% 88%",
      sidebar: "230 40% 14%",
      sidebarForeground: "225 20% 92%",
      sidebarPrimary: "240 80% 62%",
      sidebarAccent: "230 38% 20%",
    },
    dark: {
      background: "225 30% 5%",
      foreground: "225 15% 92%",
      card: "225 30% 7%",
      cardForeground: "225 15% 92%",
      primary: "235 55% 50%",
      primaryForeground: "0 0% 100%",
      secondary: "225 20% 14%",
      secondaryForeground: "225 15% 92%",
      muted: "225 20% 12%",
      mutedForeground: "225 10% 60%",
      accent: "240 80% 62%",
      accentForeground: "0 0% 100%",
      border: "225 20% 14%",
      sidebar: "230 40% 7%",
      sidebarForeground: "225 15% 90%",
      sidebarPrimary: "240 80% 62%",
      sidebarAccent: "230 38% 12%",
    },
  },
];

export function getPlatformThemeById(id: string): PlatformTheme {
  return PLATFORM_THEMES.find(t => t.id === id) || PLATFORM_THEMES[0];
}

// ── WCAG contrast helpers ────────────────────────────────────────────
// Platform palettes are decorative-first; the vars that carry meaning
// (--input control boundaries, --ring focus indicators, --accent link/label
// text) must meet WCAG 1.4.11 (3:1) / 1.4.3 (4.5:1) against the theme
// background regardless of which palette an admin picks. Rather than
// hand-tuning every palette (light+dark), we adjust lightness at apply time.
function parseHslTriplet(hsl: string): { h: number; s: number; l: number } | null {
  const m = hsl.trim().match(/^([\d.]+)\s+([\d.]+)%\s+([\d.]+)%$/);
  return m ? { h: +m[1], s: +m[2], l: +m[3] } : null;
}

function hslToLuminance(h: number, s: number, l: number): number {
  const sn = s / 100, ln = l / 100;
  const a = sn * Math.min(ln, 1 - ln);
  // sRGB relative luminance
  const lin = (n: number) => {
    const k = (n + h / 30) % 12;
    const c = ln - a * Math.max(-1, Math.min(k - 3, 9 - k, 1));
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  };
  return 0.2126 * lin(0) + 0.7152 * lin(8) + 0.0722 * lin(4);
}

function contrastRatio(lumA: number, lumB: number): number {
  const [hi, lo] = lumA >= lumB ? [lumA, lumB] : [lumB, lumA];
  return (hi + 0.05) / (lo + 0.05);
}

/**
 * Returns `color` with its lightness nudged away from the background until it
 * reaches the target contrast ratio (or the lightness bound). Hue/saturation
 * are preserved so the palette identity survives.
 */
export function ensureContrast(color: string, background: string, target: number): string {
  const c = parseHslTriplet(color);
  const bg = parseHslTriplet(background);
  if (!c || !bg) return color;
  const bgLum = hslToLuminance(bg.h, bg.s, bg.l);
  const darkBg = bg.l < 50;
  let l = c.l;
  for (let i = 0; i < 40; i++) {
    if (contrastRatio(hslToLuminance(c.h, c.s, l), bgLum) >= target) break;
    l += darkBg ? 2 : -2; // move away from the background
    if (l <= 2 || l >= 98) break;
  }
  l = Math.max(2, Math.min(98, l));
  return `${c.h} ${c.s}% ${Math.round(l)}%`;
}

export function applyPlatformTheme(colors: ThemeColors, mode: "light" | "dark") {
  const root = document.documentElement;
  const selector = mode === "dark" ? ".dark" : ":root";

  const cssVarMap: Record<string, keyof ThemeColors> = {
    "--background": "background",
    "--foreground": "foreground",
    "--card": "card",
    "--card-foreground": "cardForeground",
    "--primary": "primary",
    "--primary-foreground": "primaryForeground",
    "--secondary": "secondary",
    "--secondary-foreground": "secondaryForeground",
    "--muted": "muted",
    "--muted-foreground": "mutedForeground",
    "--accent": "accent",
    "--accent-foreground": "accentForeground",
    "--border": "border",
    "--sidebar": "sidebar",
    "--sidebar-foreground": "sidebarForeground",
    "--sidebar-primary": "sidebarPrimary",
    "--sidebar-accent": "sidebarAccent",
  };

  Object.entries(cssVarMap).forEach(([cssVar, key]) => {
    root.style.setProperty(cssVar, colors[key]);
  });

  // WCAG 1.4.3: primary button background must achieve 4.5:1 contrast with its
  // foreground text. If the theme's primary color is too light for white text
  // (common with brand blues), darken it until it passes.
  const primaryFgHsl = parseHslTriplet(colors.primaryForeground);
  const primaryBgHsl = parseHslTriplet(colors.primary);
  if (primaryFgHsl && primaryBgHsl) {
    const fgLum = hslToLuminance(primaryFgHsl.h, primaryFgHsl.s, primaryFgHsl.l);
    const bgLum = hslToLuminance(primaryBgHsl.h, primaryBgHsl.s, primaryBgHsl.l);
    if (contrastRatio(fgLum, bgLum) < 4.5) {
      // Darken (or lighten) the primary background until the foreground passes.
      // ensureContrast(color, background, target) treats `background` as fixed;
      // passing primaryForeground as the "background" reference moves the primary
      // token in the direction that achieves the required ratio.
      const a11yPrimary = ensureContrast(colors.primary, colors.primaryForeground, 4.5);
      root.style.setProperty("--primary", a11yPrimary);
    }
  }

  // WCAG overrides: accent doubles as link/label text (1.4.3, 4.5:1) and the
  // focus ring must hit 3:1 (1.4.11) against the theme background.
  const a11yAccent = ensureContrast(colors.accent, colors.background, 4.5);
  root.style.setProperty("--accent", a11yAccent);
  // If the adjusted accent no longer carries white text at 4.5:1 (light
  // accents on dark themes), flip the accent foreground dark.
  const accentHsl = parseHslTriplet(a11yAccent);
  if (accentHsl) {
    const whiteOnAccent = contrastRatio(1, hslToLuminance(accentHsl.h, accentHsl.s, accentHsl.l));
    root.style.setProperty("--accent-foreground", whiteOnAccent >= 4.5 ? colors.accentForeground : "220 40% 10%");
  }
  root.style.setProperty("--ring", ensureContrast(colors.accent, colors.background, 3));
  root.style.setProperty("--sidebar-ring", colors.sidebarPrimary);
  root.style.setProperty("--sidebar-primary-foreground", "0 0% 100%");
  root.style.setProperty("--sidebar-accent-foreground", colors.sidebarForeground);
  root.style.setProperty("--sidebar-border", colors.sidebarAccent);
  root.style.setProperty("--popover", colors.card);
  root.style.setProperty("--popover-foreground", colors.foreground);
  root.style.setProperty("--popover-border", colors.border);
  root.style.setProperty("--card-border", colors.border);
  // Control boundaries (inputs, selects, switch tracks) need 3:1 (1.4.11);
  // the palette border stays decorative for separators/cards.
  root.style.setProperty("--input", ensureContrast(colors.border, colors.background, 3));
  root.style.setProperty("--chart-1", colors.primary);
  root.style.setProperty("--chart-2", colors.accent);
}

export function hslToHex(hsl: string): string {
  const parts = hsl.trim().split(/\s+/);
  if (parts.length < 3) return "#888888";
  const h = parseFloat(parts[0]);
  const s = parseFloat(parts[1]) / 100;
  const l = parseFloat(parts[2]) / 100;

  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = l - c / 2;

  let r = 0, g = 0, b = 0;
  if (h < 60) { r = c; g = x; }
  else if (h < 120) { r = x; g = c; }
  else if (h < 180) { g = c; b = x; }
  else if (h < 240) { g = x; b = c; }
  else if (h < 300) { r = x; b = c; }
  else { r = c; b = x; }

  const toHex = (v: number) => Math.round((v + m) * 255).toString(16).padStart(2, "0");
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

export function hexToHsl(hex: string): string {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return "0 0% 50%";

  let r = parseInt(result[1], 16) / 255;
  let g = parseInt(result[2], 16) / 255;
  let b = parseInt(result[3], 16) / 255;

  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0;
  const l = (max + min) / 2;

  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
      case g: h = ((b - r) / d + 2) / 6; break;
      case b: h = ((r - g) / d + 4) / 6; break;
    }
  }

  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}
